// import { serializeTokens } from 'utils/serializeTokens'
import { SerializedFarmConfig } from '../../types'

const priceHelperLps: SerializedFarmConfig[] = []

export default priceHelperLps
